function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#379B87"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3 5L12.3 19",
  stroke: "white",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 12.3H5",
  stroke: "white",
  strokeWidth: 2
});
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.3d7900fe1b03e8b43b725f33f811339f.svg";
export { ForwardRef as ReactComponent };